// duplicated to resolve circular imports error with the reducer
export const NAME = 'perspectives';
